import { graphql } from 'react-apollo'
import { Layout, Input, Table, Form, Button, Select, InputNumber, Divider, notification } from 'antd'
import { sortWith, prop, ascend } from 'ramda'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import XLSX from 'xlsx'

import createLabelMutation from '../graphql/mutations/createLabel'
import eventsQuery from '../graphql/queries/events'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import inboxLabel from '../helpers/inbox'
import raceLabel from '../helpers/race'
import shopLabel from '../helpers/shop'
import provinceDatas from '../assets/data/provinces.json'

import '../css/form.css'

const { Content } = Layout
const FormItem = Form.Item
const { Option } = Select

const labelMapper = {
  shop: shopLabel,
  race: raceLabel,
  inbox: inboxLabel,
}

const sortLabels = labels => sortWith([
  ascend(prop('count')),
  ascend(prop('items')),
  ascend(prop('item')),
])(labels.map(label => ({
  ...label,
  count: label.data.count,
  item: label.data.items.map(item => item.name).join(', '),
  items: label.data.items.length,
})))

class ImportLabel extends Component {
  state = {
    rows: [],
    data: [],
    loadingReadFile: false,
  }

  setData = (rows) => {
    const { getFieldValue } = this.props.form
    const app = getFieldValue('app')
    const maxItems = getFieldValue('maxItems')
    const eventName = getFieldValue('eventName')
    const eventCode = getFieldValue('eventCode')
    const type = getFieldValue('type')
    const group = getFieldValue('group')
    try {
      const data = labelMapper[app].groupData({
        rows,
        group,
        eventName,
        eventCode,
        type,
        max: maxItems,
      })
      this.setState({ data: data.map(d => ({ ...d, app })) })
    } catch (err) {
      notification.error({
        message: 'Error',
        description: `Invalid template format for ${app}`,
      })
    }
  }
  handleFileChange = (event) => {
    this.setState({ loadingReadFile: true })
    let tempAddress = ''
    let arrAddress = ''
    let editAddress = ''
    let registration_id = ''

    const { getFieldValue } = this.props.form
    const app = getFieldValue('app')
    const { setFieldsValue } = this.props.form
    const { files } = event.target
    const file = files[0]
    setFieldsValue({ group: file.name.replace("%", "") })
    const reader = new FileReader()
    reader.onload = (e) => {
      const f = e.target.result
      const workbook = XLSX.read(f, { type: 'binary' })
      const sheetName = workbook.SheetNames[0]
      const worksheet = workbook.Sheets[sheetName]
      const rows = XLSX.utils.sheet_to_json(worksheet)

      if(app === 'race'){

        let stoploop = false
        rows.forEach( element => {

          if(!stoploop){

            tempAddress = ''
            editAddress = ''
            arrAddress = ''
            registration_id = ''

            tempAddress = element.reg_deliver_to_address
            registration_id = element.registration_id
          
            if(registration_id === undefined){

              notification.error({
                message: 'Error',
                description: `Invalid template format for ${app}`,
              })


              alert('ข้อมูล registration_id ไม่ครบถ้วน')
              stoploop = true
              return
            }

            if(tempAddress === undefined){
              alert('ข้อมูลที่อยู่จัดส่งไม่ครบถ้วน')
              stoploop = true
              return
            }

            arrAddress = tempAddress.split("    ")
            for(let index= 0 ; index < arrAddress.length ; index++){

              if(index <= (arrAddress.length-2)){
                if(!arrAddress[index].includes('Thailand') || arrAddress[index].length > 12){
                  editAddress = editAddress+arrAddress[index]
                }
              }else if((index === (arrAddress.length-1)) && (arrAddress[index].length < 10 || arrAddress[index].length > 50)){
                editAddress = editAddress+arrAddress[index]
              }
            }
            provinceDatas.forEach(province => {
              if(editAddress.includes(province.en)){
                editAddress = editAddress.replace(province.en, province.th)
              }
            })
            element.reg_deliver_to_address = editAddress
        }
        })
      }
      
      this.setState({ rows })
      this.setData(rows)
    }
    reader.readAsBinaryString(file)
    this.setState({ loadingReadFile: false })
  }
  handleSponsorChange = (event) => {
    const { files } = event.target
    const file = files[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const f = e.target.result
        this.setState({ sponsor: f })
      }
      reader.readAsDataURL(file)
    } else {
      this.setState({ sponsor: null })
    }
  }
  handleInputChange = (e) => {
    const { setFieldsValue } = this.props.form
    setFieldsValue({ [e.target.name]: e.target.value })
    this.setData(this.state.rows)
  }
  handleInputNumberChange = (value) => {
    const { getFieldValue, setFieldsValue } = this.props.form
    const app = getFieldValue('app')
    const type = getFieldValue('type')
    if (app !== 'race' || (app === 'race' && type === 'new')) {
      setFieldsValue({ maxItems: value })
      this.setData(this.state.rows)
    }
  }
  handleSelectChange = (value) => {
    const { setFieldsValue } = this.props.form
    setFieldsValue({ app: value })
    setFieldsValue({ maxItems: 3 })
    this.setData(this.state.rows)
  }
  handleSelectAddressChange = (value) => {
    const { setFieldsValue } = this.props.form
    setFieldsValue({ type: value })
    if (value === 'old') {
      setFieldsValue({ maxItems: 1 })
    } else {
      setFieldsValue({ maxItems: 3 })
    }
    this.setData(this.state.rows)
  }
  handleSearchEventChange = (e) => {
    const { setFieldsValue } = this.props.form
    setFieldsValue({ searchEvent: e.target.value })
    this.handleSelectEventChange(0)
  }
  handleSelectEventChange = (value) => {
    const { events: { events } } = this.props
    const { getFieldValue, setFieldsValue } = this.props.form
    const searchEvent = getFieldValue('searchEvent')
    const num = parseInt(value, 10)
    const filteredEvents = events.filter(val => val.name.match(new RegExp(searchEvent, 'igu')))
    const event = filteredEvents[num]
    if (event) {
      setFieldsValue({ event: num, eventName: event.name, eventCode: event.code })
    }
  }
  preview = () => {
    const { getFieldValue } = this.props.form
    const app = getFieldValue('app')
    const { data, sponsor } = this.state
    const sortedLabels = sortLabels(data)
    const html = labelMapper[app].genLabel(sortedLabels, sponsor)
    const wnd = window.open('about:blank', '')
    wnd.document.write(html)
    wnd.document.close()
  }
  importLabel = async () => {
    const { getFieldValue } = this.props.form
    const app = getFieldValue('app')
    const { data, sponsor } = this.state
    const sortedLabels = sortLabels(data)
    const labels = []
    await sortedLabels.asyncForEach(async (label) => {
      /* eslint no-unused-vars: 0 */
      const {
        count,
        item,
        items,
        ...record
      } = label
      const { data: { createLabel: { record: result } } } = await this.props.createLabel({ variables: { record } })
      labels.push(result)
    })
    const html = labelMapper[app].genLabel(labels, sponsor)
    const wnd = window.open('about:blank', '')
    wnd.document.write(html)
    wnd.document.close()
  }
  exportExcel = async () => {
    const { getFieldValue } = this.props.form
    const group = getFieldValue('group')
    const { data } = this.state

    const now = (new Date()).getTime() - 1534000000000
    const excelData = data.map(({
      data: d,
      seq,
      last,
      referenceId,
      recipient,
      address,
    }, index) => ({
      referenceId,
      recipient,
      address,
      items: d.items.map(item => `[${item.amount}] ${item.name}`).join('\n'),
      phones: d.phones.join(', '),
      seq: `${seq}/${last}`,
      event: '',
      tracking: `THR${(now + index)}`,
      type: 'alpha',
    }))

    const workbook = XLSX.utils.book_new()
    const worksheet = XLSX.utils.json_to_sheet(excelData)
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1')
    XLSX.writeFile(workbook, `out-${group}`)
  }
  render() {
    const { loadingReadFile } = this.state
    const { events: { loading, events } } = this.props
    const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    }
    const columns = [
      {
        title: 'Referance ID',
        dataIndex: 'referenceId',
        key: 'referenceId',
        width: 105,
      },
      {
        title: 'Recipient',
        dataIndex: 'recipient',
        key: 'recipient',
        width: 200,
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
      },
      {
        title: 'Items',
        key: 'items',
        width: 200,
        render: record => (
          <ul>
            {record.data.items.map(item => (
              <li key={`${record.referenceId} ${item.name}`}>[{item.amount}] {item.name}</li>
            ))}
          </ul>
        ),
      },
    ]
    return (
      <Layout>
        <Navbar selected="import:1" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <Form onSubmit={this.handleSubmit}>
              <FormItem
                {...formItemLayout}
                label="App"
              >
                {getFieldDecorator('app', {
                  initialValue: 'race',
                  rules: [{ required: true, message: 'Please select your app!' }],
                })(
                  <Select
                    placeholder="Select your app"
                    onChange={this.handleSelectChange}
                  >
                    <Option value="race">Race</Option>
                    <Option value="shop">Shop</Option>
                    <Option value="inbox">Inbox</Option>
                  </Select>
                )}
              </FormItem>
              {getFieldValue('app') === 'race' ? (
                <div>
                  <FormItem
                    {...formItemLayout}
                    label="Address type"
                  >
                    {getFieldDecorator('type', {
                      initialValue: 'new',
                      rules: [{ required: true, message: 'Please select address type!' }],
                    })(
                      <Select
                        placeholder="Select address type"
                        onChange={this.handleSelectAddressChange}
                      >
                        <Option value="new">New</Option>
                        <Option value="old">Old</Option>
                      </Select>
                    )}
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    label="Search event"
                  >
                    {getFieldDecorator('searchEvent', {
                      initialValue: '',
                      rules: [{ message: 'Search event by name' }],
                    })(
                      <Input type="text" name="searchEvent" onChange={this.handleSearchEventChange} />
                    )}
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    label="Event"
                  >
                    {getFieldDecorator('event', {
                      initialValue: 0,
                      rules: [{ required: true, message: 'Please select your event!' }],
                    })(
                      <Select
                        placeholder="Select your event"
                        onChange={this.handleSelectEventChange}
                      >
                        {!loading && events && events.filter(val => val.name.match(new RegExp(`${getFieldValue('searchEvent')}`, 'igu'))).map((event, index) => (
                          <Option key={event.slug} value={index}>{event.name} ({event.code})</Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    label="Event name"
                  >
                    {getFieldDecorator('eventName', {
                      initialValue: ((events && events[0].name) || ''),
                    })(
                      <Input type="text" name="eventName" onChange={this.handleInputChange} disabled />
                    )}
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    label="Event code"
                  >
                    {getFieldDecorator('eventCode', {
                      initialValue: ((events && events[0].code) || ''),
                    })(
                      <Input type="text" name="eventCode" onChange={this.handleInputChange} disabled />
                    )}
                  </FormItem>
                </div>
              ) : null}
              {getFieldValue('app') !== 'inbox' ? (
                <FormItem
                  {...formItemLayout}
                  label="Items per pack"
                >
                  {getFieldDecorator('maxItems', {
                    initialValue: 3,
                    rules: [{ required: true, message: 'Please input item per pack!' }],
                  })(
                    <InputNumber min={1} onChange={this.handleInputNumberChange} disabled={getFieldValue('app') === 'race' && getFieldValue('type') === 'old'} />
                  )}
                </FormItem>
              ) : null}
              <FormItem
                {...formItemLayout}
                label="File"
              >
                {getFieldDecorator('file', {
                  rules: [{ required: true, message: 'Please input excel file!' }],
                })(
                  <Input type="file" onChange={this.handleFileChange} />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="Group"
              >
                {getFieldDecorator('group', {
                  initialValue: '',
                  rules: [{ required: true, message: 'Please input your group name!' }],
                })(
                  <Input type="text" name="group" onChange={this.handleInputChange} />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="Sponsor"
              >
                {getFieldDecorator('sponsor', {})(
                  <Input type="file" onChange={this.handleSponsorChange} />
                )}
              </FormItem>
              <FormItem {...tailFormItemLayout}>
                <Button type="primary" style={{ marginRight: '10px' }} onClick={this.preview} loading={loadingReadFile}>Preview label</Button>
                <Button type="primary" onClick={this.importLabel} loading={loadingReadFile} >Import label</Button>
                {/* <Button type="primary" onClick={this.exportExcel}>Export excel</Button> */}
              </FormItem>
            </Form>
            <Divider />
            {this.state.data.length > 0 ? (
              <div>
                <h2>Preview</h2>
                <Table
                  rowKey={record => `${record.referenceId}-${record.seq}`}
                  dataSource={this.state.data}
                  columns={columns}
                  pagination={{ pageSize: 20 }}
                  size="small"
                />
              </div>
            ) : null}
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
ImportLabel.propTypes = {
  form: PropTypes.shape(),
}
ImportLabel.defaultProps = {
  form: {},
}

export default graphql(createLabelMutation, { name: 'createLabel' })(graphql(eventsQuery, { name: 'events' })(Form.create()(ImportLabel)))



// WEBPACK FOOTER //
// ./src/pages/ImportLabel.js